const operatorPages = {
    customers: 'OPERATOR_CUSTOMERS',
    orders: 'OPERATOR_ORDERS',
    customerDetail: 'OPERATOR_CUSTOMER_DETAIL',
    orderDetail: 'OPERATOR_ORDER_DETAIL',
    register: 'OPERATOR_REGISTER',
    help: 'HELP'
}

export default operatorPages